@use "variables" as *;

.title {
  font-size: $fontSize-m;
  padding-top: 6px;
  align-self: center;
}

.tableDiv {
  padding: $spacing-s calc(#{$spacing-s} + #{$spacing-m});
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}

.header {
  margin-bottom: $spacing-s;
}

.switchListItem {
  padding-left: $spacing-xl !important;
  padding-right: $spacing-xl !important;
}
